module.exports = __webpack_public_path__ + "img/footer4.ce782d9b.png";